(function() {
  // var cx = '012606135270128357326:t_3fhzohft0';
     var cx = '004462746438547820604:t_3fhzohft0'
  var gcse = document.createElement('script');
  gcse.type = 'text/javascript';
  gcse.async = true;
  gcse.src = '//www.google.com/cse/cse.js?cx=' + cx;
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(gcse, s);
})();

var gcs = {};
(function() {
  gcs.execute = function(el) {
    if(!/disabled/.test(el.form.className)) {
      var gse = google.search.cse.element.getElement('searchresults-only0');
      if(el.value)
        gse.execute(el.value);
      else
        gse.clearAllResults();
    }
    return false;
  }
  gcs.enable = function(el) {
    el.form.className='';
    el.value = '';
  }
})()
